import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { AppInsightsService } from '../../services/appinsights/appinsights.service';

@Component({
  selector: 'prompt-component',
  templateUrl: './prompt.component.html',
  standalone: false
})
export class PromptComponent implements OnInit{
  view: string;
  constructor(
    public dialogRef: MatDialogRef<PromptComponent>, private appInsightsService: AppInsightsService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.view = data.localeView;
    this.appInsightsService.logPageView('PromptComponent');
    
  }

  ngOnInit() {
  }

  onContinueOptAction(continues:boolean){
    this.dialogRef.close(continues);
    this.appInsightsService.logEvent(`closed prompt restriction, customer continue with worflow ${continues}`);
  }
}
